let HELP_CENTER_KEYS = /*#__PURE__*/function (HELP_CENTER_KEYS) {
  HELP_CENTER_KEYS["additionalCharges"] = "additional-charges";
  HELP_CENTER_KEYS["cancelShipment"] = "cancel-shipment";
  HELP_CENTER_KEYS["cashOnDelivery"] = "cash-on-delivery";
  HELP_CENTER_KEYS["customsInvoices"] = "customs-invoices";
  HELP_CENTER_KEYS["customsPdfForm"] = "customs-pdf-form";
  HELP_CENTER_KEYS["customsRegulations"] = "customs-regulations";
  HELP_CENTER_KEYS["deferredPayments"] = "deferred-payments";
  HELP_CENTER_KEYS["insurance"] = "insurance";
  HELP_CENTER_KEYS["invoice"] = "invoice";
  HELP_CENTER_KEYS["keepInvoice"] = "keep-invoice";
  HELP_CENTER_KEYS["packagingGuide"] = "packaging-guide";
  HELP_CENTER_KEYS["privacyPolicy"] = "privacy-policy";
  HELP_CENTER_KEYS["prohibitedItems"] = "prohibited-items";
  HELP_CENTER_KEYS["prohibitedItemsGotoProhibited"] = "prohibited-items-goto-prohibited";
  HELP_CENTER_KEYS["prohibitedItemsGotoRestricted"] = "prohibited-items-goto-restricted";
  HELP_CENTER_KEYS["requirementsOpenClaim"] = "requirements-open-claim";
  HELP_CENTER_KEYS["termsAndConditions"] = "terms-and-conditions";
  HELP_CENTER_KEYS["carriersTermsAndConditions"] = "carriers-terms-and-conditions";
  HELP_CENTER_KEYS["requestDeferred"] = "request-deferred";
  HELP_CENTER_KEYS["damagedParcel"] = "damaged-parcel";
  HELP_CENTER_KEYS["ticketLink"] = "ticket-link";
  HELP_CENTER_KEYS["subscriptionsTermsAndConditions"] = "subscriptions-terms-and-conditions";
  HELP_CENTER_KEYS["home"] = "home";
  HELP_CENTER_KEYS["weightDeviationPolicy"] = "weight-deviation-policy";
  HELP_CENTER_KEYS["brandedEmails"] = "branded-emails";
  HELP_CENTER_KEYS["premiumSupport"] = "premium-support";
  HELP_CENTER_KEYS["unknownCharges"] = "unknown-charges";
  HELP_CENTER_KEYS["getAnInvoice"] = "get-an-invoice";
  HELP_CENTER_KEYS["paymentError"] = "payment-error";
  HELP_CENTER_KEYS["cancelAShipment"] = "cancel-a-shipment";
  HELP_CENTER_KEYS["refundWhen"] = "refund-when";
  HELP_CENTER_KEYS["cancellationPolicy"] = "cancellation-policy";
  HELP_CENTER_KEYS["proofOfDelivery"] = "proof-of-delivery";
  HELP_CENTER_KEYS["missingParcels"] = "missing-parcels";
  HELP_CENTER_KEYS["monthlyInvoice"] = "monthly-invoice";
  HELP_CENTER_KEYS["shippingRates"] = "shipping-rates";
  HELP_CENTER_KEYS["windsorFramework"] = "windsor-framework";
  return HELP_CENTER_KEYS;
}({});
let SUPPORT_CENTER_KEYS = /*#__PURE__*/function (SUPPORT_CENTER_KEYS) {
  SUPPORT_CENTER_KEYS["home"] = "support-center";
  SUPPORT_CENTER_KEYS["newTicket"] = "support-center-new-ticket";
  SUPPORT_CENTER_KEYS["ticketLink"] = "ticket-link";
  return SUPPORT_CENTER_KEYS;
}({});

export { HELP_CENTER_KEYS, SUPPORT_CENTER_KEYS };
//# sourceMappingURL=types.js.map
